import { NextPageWithLayout } from 'next';
import React, { ReactElement } from 'react';
import StaticPageComponent from '@fuww/library/src/StaticPage';
import { PluggableList } from 'react-markdown/lib/react-markdown';
import ReactMarkdown from 'react-markdown';
import { useIntl } from 'react-intl';
import rehypeSlug from 'rehype-slug';
import markdown from '../data/staticPages/privacy-statement.md';
import Layout from '../components/Layout';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from '../lib/messages.json';
import HomeLink from '../components/HomeLink';
import Head from '../components/Head';

const PrivacyStatementPage: NextPageWithLayout = () => {
  const intl = useIntl();

  const breadcrumbs = [
    <HomeLink />,
    <LinkAndAnchor
      route="privacy-statement"
      passHref
    >
      {intl.formatMessage(messages['privacyStatement.title'])}
    </LinkAndAnchor>,
  ];

  return (
    <>
      <Head
        title={intl.formatMessage(messages['privacyStatement.title'])}
        description={intl.formatMessage(messages['privacyStatement.title'])}
      />
      <StaticPageComponent
        content={(
          <ReactMarkdown
            rehypePlugins={
              [rehypeSlug] as PluggableList
            }
          >
            {markdown}
          </ReactMarkdown>
        )}
        title={intl.formatMessage(messages['privacyStatement.title'])}
        breadcrumbs={breadcrumbs}
      />
    </>
  );
};

PrivacyStatementPage.getLayout = (page: ReactElement) => (
  <Layout>
    {page}
  </Layout>
);

export default PrivacyStatementPage;
